import React from "react";

import { useFooterData } from "hooks/queries/useFooterData.query";
import "./footer.scss";
import MenuItem from "components/menu/menuItem";
import Logo from "assets/aligned-logo-white.svg";
import { flatListToHierarchical } from "utils/navHelper.utils";
import Icon from "components/icon/Icon";
import { Link } from "gatsby";
import { TransLink } from "components/trans/transLink";

interface Props {}

const Footer: React.FC<Props> = (props) => {
  const { menu, legal, social, cta } = useFooterData();
  const year = new Date().getFullYear();

  return (
    <div className="footer">
      <div className="footer__wrapper">
        {/* CTA MOBILE */}
        <ul className="footer-cta is-mobile">
          {cta.menuItems.nodes.map((item: any, key: any) => (
            <MenuItem
              className="footer-cta__item"
              isButton={true}
              {...item}
              key={key}
            />
          ))}
        </ul>
        <div className="footer__left">
          {/* LOGO */}
          <div className="footer-logo">
            <TransLink to="/">
              <Logo />
            </TransLink>
          </div>
          {/* SOCIAL ICONS */}
          <ul
            className="footer-social"
            style={{ maxWidth: `${70 * social.menuItems.nodes.length}px` }}
          >
            {social.menuItems.nodes.map((item: any, key: any) => (
              <li key={key} className="footer-social__item">
                <a
                  href={item.path}
                  target="_blank"
                  rel="norefferer"
                  className="footer-social__link"
                >
                  <Icon icon={item.label} color="#fff" />
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer__right">
          <div className="footer__right-top">
            {/* MAIN MENU */}
            <ul className="footer-menu">
              {flatListToHierarchical(menu.menuItems.nodes).map(
                (item: any, key: any) => (
                  <MenuItem
                    {...item}
                    collapsableList={true}
                    key={key}
                    className="footer-menu__item"
                    classNameSub="footer-menu__item-sub"
                  />
                )
              )}
            </ul>
            {/* CTA DESKTOP */}
            <ul className="footer-cta is-desktop">
              {cta.menuItems.nodes.map((item: any, key: any) => (
                <MenuItem
                  className="footer-cta__item"
                  {...item}
                  key={key}
                />
              ))}
            </ul>
          </div>
          {/* LEGAL */}
          <ul className="footer-legal">
            {legal.menuItems.nodes.map((item: any, key: any) => (
              <MenuItem {...item} key={key} className="footer-legal__item" />
            ))}
            <li className="footer-legal__item is-copyright">
              &copy; Aligned {year}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
